import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { MenuService } from '../theme/components/menu/menu.service';

import { HttpClient  } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { Observable  } from 'rxjs/Observable';
import { startWith   } from 'rxjs/operators/startWith';
import { map         } from 'rxjs/operators/map';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [ MenuService ]
})
export class PagesComponent implements OnInit { 

  @ViewChild('sidenav') sidenav:any;
  public settings:Settings;
  public menus = ['vertical', 'horizontal'];
  public menuOption:string;
  public menuTypes = ['default', 'compact', 'mini'];
  public menuTypeOption:string;
  public isStickyMenu:boolean = false;
  public lastScrollTop:number = 0;
  public showBackToTop:boolean = false;
  public toggleSearchBar:boolean = false;
  private defaultMenu:string; //declared for return default menu when window resized 
  public scrolledContent:any;

  constructor(
    public appSettings:AppSettings, 
    public router:Router, 
    private menuService: MenuService,
    private http: HttpClient
  ){        
    this.settings = this.appSettings.settings;
  }
  
  ngOnInit() {
    if(window.innerWidth <= 768){
      // this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
    }
    this.menuOption = this.settings.menu; 
    this.menuTypeOption = this.settings.menuType; 
    this.defaultMenu = this.settings.menu;

    console.log( "begin : init KCC bar" );
    this.searchKccId();
    this.initialKccBar();
    console.log( "end : init KCC bar" );
  }

  ngAfterViewInit(){
    console.log( "begin : ngAfterViewInit" );
    setTimeout(() => { this.settings.loadingSpinner = false }, 300)  
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) { 
        if(!this.settings.sidenavIsPinned){
          this.sidenav.close(); 
        }      
        if(window.innerWidth <= 768){
          this.sidenav.close(); 
        } 
      }
    });
    if(this.settings.menu == "vertical")
      this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems());
    console.log( "end : ngAfterViewInit" );
  }
  
  //== ==============================================================================
  //== ~ KCC BAR
  //== ------------------------------------------------------------------------------
  // kccIdObj: any;
  debtorObj: any;
  dtCodeOptions                      = [];
  filteredDtCodeControl: FormControl = new FormControl();
  filteredDtCodeOptions: Observable<string[]>;
  txtKccId      = "";
  txtDebtorCode = "";
  initialKccBar(){
    this.debtorObj            = {};
    this.filteredDtCodeOptions = this.filteredDtCodeControl.valueChanges
      .pipe(
        startWith(''),
        map(val => this.filterDtCode(val))
      );
  }
  searchKccId(){

    this.http.get( '/lkccidq1/' ).subscribe( res => {

      this.debtorObj     = {};
      this.dtCodeOptions = [];

      for( var x in res ){
      
        var kccId  = res[ x ][ "KCC_DT_ID" ];
        var dtCode = res[ x ][ "DT_CODE"   ];

        this.debtorObj[ dtCode ] = kccId;

      }//-- END : for

      for( var y in this.debtorObj ){

        this.dtCodeOptions.push( y );

      }//-- END : for

      console.log("debtorObj",this.debtorObj);
      console.log("dtCodeOptions",this.dtCodeOptions);

    });
  }//-- END : searchKccId
  filterDtCode(val): string[] {
    if( this.debtorObj[ this.filteredDtCodeControl.value ] ){
      this.txtKccId = this.debtorObj[ this.filteredDtCodeControl.value ]
    }else{
      this.txtKccId = "";
    }
    return this.dtCodeOptions.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }
  // showKccId(){
  //   this.txtDebtorCode = this.txtDebtorCode.trim();
  //   this.txtKccId      = this.debtorObj[ this.filteredDtCodeControl.value ]
  // }
  //== ==============================================================================

  public chooseMenu(){
    this.settings.menu = this.menuOption; 
    this.defaultMenu = this.menuOption;
    this.router.navigate(['/']); 
  }

  public chooseMenuType(){
    this.settings.menuType = this.menuTypeOption;
  }

  public changeTheme(theme){
    this.settings.theme = theme;       
  }
   
  public toggleSidenav(){
    this.sidenav.toggle();
  }
  
  public onPsScrollY(event){
    this.scrolledContent = event.target;
    (this.scrolledContent.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false; 
    if(this.settings.menu == 'horizontal'){
      if(this.settings.fixedHeader){
        var currentScrollTop = (this.scrolledContent.scrollTop > 56) ? this.scrolledContent.scrollTop : 0;   
        (currentScrollTop > this.lastScrollTop) ? this.isStickyMenu = true : this.isStickyMenu = false;
        this.lastScrollTop = currentScrollTop; 
      } 
      else{
        (this.scrolledContent.scrollTop > 56) ? this.isStickyMenu = true : this.isStickyMenu = false;  
      }
    } 
  }

  public scrollToTop(){
    var scrollDuration = 200;
    var scrollStep = -this.scrolledContent.scrollTop / (scrollDuration / 20);
    var scrollInterval = setInterval(()=>{
      if(this.scrolledContent.scrollTop != 0){
         this.scrolledContent.scrollBy(0, scrollStep);
      }
      else{
        clearInterval(scrollInterval); 
      }
    },10);
    if(window.innerWidth <= 768){
      this.scrolledContent.scrollTop = 0;
    }
  }

  @HostListener('window:resize')
  public onWindowResize():void {
    if(window.innerWidth <= 768){
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical'
    }
    else{
      (this.defaultMenu == 'horizontal') ? this.settings.menu = 'horizontal' : this.settings.menu = 'vertical'
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
    }
  }

  public closeSubMenus(){
    let menu = document.querySelector(".sidenav-menu-outer");
    if(menu){
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if(child){
          if(child.children[0].classList.contains('expanded')){
              child.children[0].classList.remove('expanded');
              child.children[1].classList.remove('show');
          }
        }
      }
    }
  }

}